import { useState, useEffect } from 'react'

import './Carousel.css'

const images = [
  'https://i.imgur.com/ivggikW.png',
  'https://i.imgur.com/cMJHjc5.png',
  'https://i.imgur.com/nhe3mwI.png'
]

function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
    }, 2500) // Cambia cada 3 segundos

    return () => clearInterval(interval)
  }, []);

  return (
    <div className='carousel-container'>
      <div className='overlay'></div>
      {images.map((img, index) => (
        <div
          key={index}
          className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}
    </div>
  )
}

export default Carousel